module.exports = __webpack_public_path__ + "static/media/image-download.ac90a739.svg";